module.exports = __webpack_public_path__ + "static/media/ERGE-faq.2a8107d1.jpg";